import React, { useCallback, useEffect, useMemo, useState } from "react";
import leftArrow from "../../../assets/images/left-arrow.svg";
import walletIcon from "../../../assets/images/wallet-icon.svg";
import dahsIcon1 from "../../../assets/images/dash-icon-1.svg";
import dahsIcon2 from "../../../assets/images/dash-icon-2.svg";
import dahsIcon3 from "../../../assets/images/dash-icon-3.svg";
import dahsIcon4 from "../../../assets/images/dash-icon-4.svg";
import rightArrow from "../../../assets/images/ArrowRight.svg";
import CopyLink from "../../../assets/images/CopyLinkIcon.svg";
import product1 from "../../../assets/images/product-1.svg";
import product2 from "../../../assets/images/product-2.svg";
import product3 from "../../../assets/images/product-3.svg";
import downArrowWhite from "../../../assets/images/down-arrow-white.svg";
import _ from "lodash";
import Chart from "react-apexcharts";
import no_affiliate_1 from "../../../assets/images/no_affiliate_1.png";

import $ from 'jquery';
import { useSelector } from "react-redux";
import { getAffiliateDashboard, getGraphDetails, getSellGraphDetails, getStoreDetails, onGetAffiliateProducts } from "../../../services";
import { useHistory } from "react-router-dom";
import { useToast } from "../../../toast";
import AffiliateDashboardShimmer from "./AffiliateDashboardShimmer";
import moment from "moment";
import { numberConversion } from "../../../utils/common";

const AffiliateDashboard = () => {
  const profileDetails = useSelector((state) => state.profileDetails)
  const [dashboardDetails, setDashboardDetails] = useState({})
  const [storeDetails, setStoreDetails] = useState({})
  const [filterValue, setFilterValue] = useState(1)
  const [enableViewAll, setEnableViewAll] = useState(false)
  const history = useHistory()
  const toast = useToast()
  const [product, setproduct] = useState([])
  const [graphDetails, setGraphDetails] = useState([])
  const [totalProducts, setTotalProducts] = useState(0);
  const [showtotalsales, setShowtotalsales] = useState(false)
  const [showstorevisit, setShowstorevisit] = useState(false)
  const [selectedgraphDetails, setSelectedGraphDetails] = useState([])
  const [clickDataGraph, setClickDataGraph] = useState([])
  const [visitData, setVisitData] = useState([])
  const [totalSalesData, setTotalSalesData] = useState([])
  const [currPage, setCurrPage] = useState(1);
  const [prevPage, setPrevPage] = useState(0);
  const [lastList, setLastList] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false)
  const [isRender, setIsRender] = useState(true)
  const [totalSalesGraphDetails, setTotalSalesGraphDetails] = useState([])

  useEffect(() => {
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [currPage]);

  useEffect(() => {
    function handleWindowResize() {
      if (window?.outerWidth <= 750) {
        setIsMobileView(true)
      } else {
        setIsMobileView(false)
      }
    }
    handleWindowResize()
    window.addEventListener('resize', handleWindowResize);
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, [])
  useEffect(() => {
    const fetchData = async () => {
      let payload = {
        page: currPage - 1,
        limit: 10
      }
      setLoading(true)
      const res = await onGetAffiliateProducts(payload).then((res) => res).catch(err => setLoading(false))
      setLoading(false)
      if (!res.data.length) {
        setLastList(true);
        return;
      }
      setTotalProducts(res.totalItems)
      setPrevPage(currPage);
      setproduct([...product, ...res.data]);
    };
    if (!lastList && prevPage !== currPage) {
      fetchData();
    }
  }, [currPage, lastList, prevPage, product]);

  useEffect(() => {
    //TOGGLING NESTED ul
    $(".drop-down .selected a").click(function () {
      $(".drop-down .options ul").toggle();
    });

    //SELECT OPTIONS AND HIDE OPTION AFTER SELECTION
    $(".drop-down .options ul li a").click(function () {
      var text = $(this).html();
      setFilterValue(text === "Last 24 hours" ? 1 : text === "Last 7 days" ? 2 : text === "Last 30 days" ? 3 : text === "Overall" ? 4 : "")
      $(".drop-down .selected a span").html(text);
      $(".drop-down .options ul").hide();
    });


    //HIDE OPTIONS IF CLICKED ANYWHERE ELSE ON PAGE
    $(document).bind('click', function (e) {
      var $clicked = $(e.target);
      if (!$clicked.parents().hasClass("drop-down"))
        $(".drop-down .options ul").hide();
    });
  }, [isRender]);

  const onCopyLink = () => {
    if (storeDetails?.status) {
      navigator.clipboard.writeText(`${window.location.origin}/${profileDetails?.cp_creator_domains[0]?.domain_name}`);
      toast.buttomOpen("Link copied to clipboard");
    } else {
      toast.buttomOpen("Please make your store online in order to share the link");
    }
  }
  const onScroll = () => {
    const scrollTop = document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;
    if (!enableViewAll) {
      return
    }
    if (scrollTop + clientHeight >= scrollHeight) {
      setCurrPage(currPage + 1);
    }
  };
  useEffect(() => {
    if (enableViewAll) {
      onScroll()
    }
  }, [enableViewAll])

  const onViewAllClick = () => {
    setEnableViewAll(true)
  }
  const daysConverter = (day, finalArray) => {
    const days = finalArray
    let index = 0
    days?.map((a, i) => {
      if (a === day) {
        return index = i
      }
    })
    return index
  }

  const onDaysUpdate = useCallback((finalArray) => {
    const clickData = Array(7).fill(null)
    const visitData = Array(7).fill(null)
    const daysGraphDetails = Array(7).fill(0)
    graphDetails?.clicks_data?.map((a) => {
      clickData.splice(daysConverter(a?.day, finalArray), 1, a?.count);
    })
    graphDetails?.visitData?.map((a) => {
      visitData.splice(daysConverter(a?.day, finalArray), 1, a?.count);
    })
    totalSalesGraphDetails?.map((a) => {
      daysGraphDetails.splice(daysConverter(a?.day, finalArray), 1, a?.count);
    })
    setTotalSalesData(daysGraphDetails)
    setClickDataGraph(clickData)
    setVisitData(visitData)
  }, [graphDetails])
  const onWeekUpdate = useCallback(() => {
    setSelectedGraphDetails(onUpdate())
    const clickData = Array(5).fill(null)
    const visitData = Array(5).fill(null)
    const graphWeekData = Array(5).fill(0)
    graphDetails?.clicks_data?.map((a) => {
      clickData.splice(a?.week - 1, 1, a?.count);
    })
    graphDetails?.visitData?.map((a) => {
      visitData.splice(a?.week - 1, 1, a?.count);
    })
    totalSalesGraphDetails?.map((a) => {
      graphWeekData.splice(a?.week - 1, 1, a?.count);
    })
    setTotalSalesData(graphWeekData)
    setClickDataGraph(clickData)
    setVisitData(visitData)
  }, [graphDetails])

  const onHandleDays = (data, finalArray, initial) => {
    const initialData = Array(7).fill(initial)
    data.map((a) => {
      initialData.splice(daysConverter(a?.day, finalArray), 1, a?.count);
    })
    return initialData
  }
  const onUpdate = () => {
    let dates = [];
    for (var i = 0; i < 30; i++) {
      let date = moment(new Date()).subtract(i, 'day').format('DD/MM/YYYY');
      dates = [date, ...dates]
    }
    let splitbydays = []
    const chunkSize = 7;
    for (let i = 0; i < dates.length; i += chunkSize) {
      const chunk = dates.slice(i, i + chunkSize);
      splitbydays = [...splitbydays, chunk]
    }

    splitbydays = splitbydays.map((data = []) => {
      let weekdays = data;
      let startdate = moment(weekdays[0], "DD/MM/YYYY").format("DD MMM 'YY")
      let endDate = moment(weekdays[weekdays.length - 1], "DD/MM/YYYY").format("DD MMM 'YY")
      weekdays = `${startdate} - ${endDate}`
      return weekdays

    })
    return splitbydays || []
  }
  useEffect(() => {
    if (!Object.keys(graphDetails)?.length) {
      return
    }
    if (filterValue === 2) {
      let days = [];
      let date = [];
      let daysRequired = 6
      for (let i = 0; i <= daysRequired; i++) {
        days.push(moment().subtract(i, 'days').format('dddd'))
      }
      for (let i = 0; i <= daysRequired; i++) {
        date.push(moment().subtract(i, 'days').format("DD MMM 'YY"))
      }
      setSelectedGraphDetails(date.reverse())
      onDaysUpdate(days.reverse())
    }
    else if (filterValue === 3) {
      onWeekUpdate()
    }
    else if (filterValue === 1) {
      const data = timeUpdateFunction()
      // setSelectedGraphDetails(data)
      let visitData = Array(12).fill(null)
      let clickData = Array(12).fill(null)
      let graphHoursData = Array(12).fill(0)
      if (isMobileView) {
        visitData = Array(6).fill(null)
        clickData = Array(6).fill(null)
        graphHoursData = Array(6).fill(0)
      }
      data?.map((a, i) => {
        graphDetails?.visitData?.map(b => {
          const temp = a?.split(" - ")
          if (parseInt(temp[0]) === 23 || parseInt(temp[0]) === 22) {
            if ((parseInt(b?.hour) >= parseInt(temp[0]))) {
              visitData.splice(i, 1, visitData[i] ? visitData[i] + b?.count : parseInt(b?.count));
              return b?.count
            }
          }
          if ((parseInt(b?.hour) >= parseInt(temp[0])) && (parseInt(b?.hour) < parseInt(temp[1]))) {
            visitData.splice(i, 1, visitData[i] ? visitData[i] + b?.count : parseInt(b?.count));
            return b?.count
          }
        })
        graphDetails?.clicks_data?.map(b => {
          const temp = a?.split(" - ")
          if (parseInt(temp[0]) === 23 || parseInt(temp[0]) === 22) {
            if ((parseInt(b?.hour) >= parseInt(temp[0]))) {
              clickData.splice(i, 1, clickData[i] ? clickData[i] + b?.count : parseInt(b?.count));
              return b?.count
            }
          }
          if ((parseInt(b?.hour) >= parseInt(temp[0])) && (parseInt(b?.hour) < parseInt(temp[1]))) {
            clickData.splice(i, 1, clickData[i] ? clickData[i] + b?.count : parseInt(b?.count));
            return b?.count
          }
        })
        totalSalesGraphDetails?.map(b => {
          const temp = a?.split(" - ")
          if (parseInt(temp[0]) === 23 || parseInt(temp[0]) === 22) {
            if ((parseInt(b?.hour) >= parseInt(temp[0]))) {
              graphHoursData.splice(i, 1, graphHoursData[i] ? graphHoursData[i] + b?.count : parseInt(b?.count));
              return b?.count
            }
          }
          if ((parseInt(b?.hour) >= parseInt(temp[0])) && (parseInt(b?.hour) < parseInt(temp[1]))) {
            graphHoursData.splice(i, 1, graphHoursData[i] ? graphHoursData[i] + b?.count : parseInt(b?.count));
            return b?.count
          }
        })
      })
      setTotalSalesData(graphHoursData)
      setClickDataGraph(clickData)
      setVisitData(visitData)
    } else if (filterValue === 4) {
      let month = [];
      let monthRequired = 12
      for (let i = 0; i < monthRequired; i++) {
        month.push(moment().subtract(i, 'months').format('MMM'))
      }
      onMonthUpdate(month)
    }

  }, [filterValue, graphDetails, isMobileView])
  const customizedFunction = (value) => {
    if (value < 10) {
      return `0${value}`
    } else {
      return value
    }
  }
  const UpdatedFormat = ((temp) => temp > 12 ? `${customizedFunction(temp - 12)} PM` : `${temp ? customizedFunction(temp) : 12} AM`)
  const timeUpdateFunction = () => {
    var d = new Date();
    const array = []
    const updatedTime = []
    let j = d.getHours()
    let loopingLength = isMobileView ? 5 : 11
    let loopingInterval = isMobileView ? 4 : 2
    for (let i = 0; i <= loopingLength; i++) {
      let temp = j
      j += loopingInterval
      if (j >= 24) {
        j = j - 24
      }
      array.push(`${customizedFunction(temp)} - ${customizedFunction(j)}`)
      updatedTime.push(`${(UpdatedFormat(temp))} - ${(UpdatedFormat(j))}`)
    };
    array.push(array.shift())
    updatedTime.push(updatedTime.shift())
    setSelectedGraphDetails(updatedTime)
    return array
  }
  useEffect(() => {
    if (!_.isEmpty(profileDetails)) {
      if (profileDetails?.cp_creator_domains?.length > 0) {
        getAffiliateDashboard({ "filter": filterValue }).then(res => {
          if (res.status) {
            const data = res?.data
            if (data?.store_product_count === 0) {
              window.open("https://stage-creatorpro.myjosh.in/affiliate_store/index?d_type=web&src=add-product", "_self")
              return
            }
            setIsRender(false)
            setDashboardDetails({
              ...data,
              cal_sale: data.total_sale - data.total_sale_last_update,
              cal_click: data.total_click - data.total_click_last_update,
              cal_visit_count: data.store_visit_count - data.store_last_updated_visitcount
            })
          }
        })
        getGraphDetails({ "filter": filterValue }).then(res => {
          setGraphDetails(res.data)
        if (res.data?.visitData?.length <= 0 || res.data?.clickDataGraph?.length <= 0) {
            setShowstorevisit(false)
          } else {
            setShowstorevisit(true)
          }
        })
        getSellGraphDetails({ "filter": filterValue }).then(res => {
          setTotalSalesGraphDetails(res.data.data)
          if(res.data.data?.length<=0){
            setShowtotalsales(false)
          }else{
            setShowtotalsales(!showtotalsales)
            }
        })
        getStoreDetails().then(res => {
          if (res.status) {
            setStoreDetails({ ...res.data, actionStatus: res.data.status ? "Online" : "Offline" })
          }
        })
      }
    }
  }, [profileDetails, filterValue])

  // useEffect(()=>{
  //   if (graphDetails?.visitData?.length <= 0 || graphDetails?.clickDataGraph?.length <= 0) {
  //     setShowstorevisit(false)
  //   } else {
  //     setShowstorevisit(true)
  //   }
  // },[])
   
  // useEffect(()=>{
  //  if(totalSalesGraphDetails?.length<=0){
  //     setShowtotalsales(false)
  //   }else{
  //     setShowtotalsales(!showtotalsales)
  //     }
  //   },[])

  const onshowTotalSales = () => {
    // if(totalSalesGraphDetails?.length<=0){
    //   setShowtotalsales(false)
    // }else{
    setShowtotalsales(!showtotalsales)
    // }
  }
  
  const onshowstorevisits = () => {
    // if (graphDetails?.visitData?.length <= 0 || graphDetails?.clickDataGraph?.length <= 0) {
    //   setShowstorevisit(false)
    // } else {
      setShowstorevisit(!showstorevisit)
    // }
  }
  const series3 = [
    {
      name: "Store Visits",
      data: visitData,
    },
    {
      name: "Clicks",
      data: clickDataGraph
    }
  ];
  const options3 = {
    colors: ['#6359e9', '#64cff6'],

    chart: {
      type: "bar",
      height: 350,
      toolbar: {
        show: false,
      },

    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "45%",
        endingShape: "rounded",
        borderRadius: 2,
      },
    },
    dataLabels: {
      enabled: false
    },
    yaxis: [
      {
        title: {
          text: "Store Visits",
          style: {
            color: "#6359e9",
          }
        },
        labels: {
          formatter: function (value) {
            return numberConversion(value);
          },
          style: {
            colors: ["#6359e9"],
          }
        },
      },
      {
        opposite: true,
        title: {
          text: "Clicks",
          style: {
            color: "#64cff6",
          }
        },
        labels: {
          formatter: function (value) {
            return numberConversion(value);
          },
          style: {
            colors: ["#64cff6"],
          }
        },
      }
    ],

    xaxis: {
      labels: {
        rotate: -55,
        hideOverlappingLabels: false
      },
      title: {
        text: "Time Period",
        style: {
          color: "white"
        },
        position: "bottom",
        offsetY: filterValue === 1 && !isMobileView ? -21 : filterValue !== 3 && isMobileView ? 0 : 6
      }
    },
    legend: {
      height: filterValue === 1 && !isMobileView ? 0 : 50,
      offsetX: 10
    },
    labels: selectedgraphDetails,
    stroke: {
      show: true,
      width: 5,
      colors: ["transparent"],
    },
    grid: {
      borderColor: 'white',
      strokeDashArray: 0,
      opacity: 0.5,
      xaxis: {
        lines: {
          show: false,
        }
      },
      yaxis: {
        lines: {
          show: false,
          // color: '#000000'
        }
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      fillSeriesColor: true,
      intersect: true,
      shared: false,
      custom: function ({ series, seriesIndex, dataPointIndex }) {
        var element = document.querySelectorAll('.chart2 .apexcharts-tooltip')[0];
        const backgroundColor = seriesIndex ? "#64cff6" : "#6359e9"
        element.style.backgroundColor = backgroundColor
        element.style.color = 'white'
        element.style.border = 'none'
        element.style.padding = '10px'
        return (
          '<div className="arrow_box p-2">' +
          "<span><b>" + selectedgraphDetails?.[dataPointIndex] + "</b><br/> " +
          numberConversion(series[seriesIndex][dataPointIndex]) +
          "</div>"
        );
      },
    }
  };
  const series2 = [
    {
      name: "Age",
      data: totalSalesData,
    },
  ];


  const options2 = {
    chart: {
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,

    },
    grid: {
      borderColor: 'white',
      strokeDashArray: 0,
      opacity: 0.5,
      xaxis: {
        lines: {
          show: false,

        }
      },
      yaxis: {
        lines: {
          show: false,
        }
      },
    },
    scales: {
      yaxis: [{
        gridLines: {

          color: "white"
        }
      }]
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 0.2,
        opacityFrom: 0.0,
        opacityTo: 0.0,
        stops: [0, 90, 100]
      }
    },
    yaxis: {
      title: {
        text: "Values", style: {
          color: "white",
        }
      },
      ...(!totalSalesData?.every(a => a === 0) && {
        labels: {
          formatter: function (value) {
            return numberConversion(value)
          },
        }
      })
    },
    xaxis: {
      labels: {
        rotate: -55,
        hideOverlappingLabels: false
      },
      tickPlacement: 'between',
      categories: selectedgraphDetails,
      title: {
        text: "Time Period",
        style: {
          color: "white"
        },
        position: "bottom",
        offsetY: filterValue === 1 && !isMobileView ? -21 : filterValue !== 3 && isMobileView ? 0 : 6
      }, tooltip: {
        enabled: false
      }
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex }) {
        var element = document.querySelectorAll('.chart1 .apexcharts-tooltip')[0];
        element.style.backgroundColor = "#1fcb4f"
        element.style.color = 'white'
        element.style.border = 'none'
        element.style.padding = '10px'
        return (
          '<div className="arrow_box">' +
          "<span><b>Sales</b> " +
          numberConversion(series[seriesIndex][dataPointIndex]) +
          "</div>"
        );
      },
    },
  };
  const handleStoreNavigate = () => {
    // if (!dashboardDetails?.store_product_count) {
    //   window.open("https://stage-creatorpro.myjosh.in/affiliate_store/index?d_type=web&src=add-product", "_self")
    //   return
    // }
    return history.push('/store-online')
  }
  const onGetIndex = (index) => index

  const handleFollowUpAction = (action, array) => {
    let index = ""
    switch (action) {
      case array[0]:
      case array[1]:
        index = onGetIndex(0)
        break
      case array[2]:
      case array[3]:
        index = onGetIndex(1)
        break
      case array[4]:
      case array[5]:
        index = onGetIndex(2)
        break
      case array[6]:
      case array[7]:
        index = onGetIndex(3)
        break
      case array[8]:
      case array[9]:
        index = onGetIndex(4)
        break
      case array[10]:
      case array[11]:
        index = onGetIndex(5)
        break
    }
    return index
  }
  const onUpdateMonth = (data, onCallback, length, initial) => {
    let updatedList = Array(length).fill(initial)
    data?.map((a) => {
      const index = onCallback(a?.month_name?.match(/.{1,3}/g)[0])
      updatedList?.splice(index, 1, updatedList[index] ? updatedList[index] + a?.count : a?.count);
    })
    return updatedList
  }

  const onMonthUpdate = useCallback((finalArray) => {
    setSelectedGraphDetails(finalArray.reverse())
    const onCallback = (value) => isMobileView ? handleFollowUpAction(value, finalArray) : daysConverter(value, finalArray)
    const arrayLength = isMobileView ? 6 : 12
    if (isMobileView) {
      let temp = [finalArray[finalArray.length - 1]]
      let temp1 = []
      for (let i = 0; i < finalArray.length; i++) {
        if (i % 2) {
          temp = [...temp, finalArray[i]]
          temp1 = [...temp1, `${temp[temp.length - 2]} - ${finalArray[i]}`]
        }
      }
      setSelectedGraphDetails(temp1)
    }
    setTotalSalesData(onUpdateMonth(totalSalesGraphDetails, onCallback, arrayLength, 0))
    setClickDataGraph(onUpdateMonth(graphDetails?.clicks_data, onCallback, arrayLength, null))
    setVisitData(onUpdateMonth(graphDetails?.visitData, onCallback, arrayLength, null))
  }, [graphDetails, isMobileView, totalSalesGraphDetails])

  const onAddProduct = () => {
    localStorage.setItem("product_count", "0")
    window.open("https://stage-creatorpro.myjosh.in/affiliate_store/index?d_type=web&src=add-product", "_self")
  }
  if (isRender) {
    return
  }

  return (
    <>
      <div className="mobile-responsive-bar bar-block">
        <div className="mobile-header-wrap d-block d-md-none d-flex mob-header">
          <img onClick={() => history.goBack()} className="leftArrow" src={leftArrow} alt="" />
          <p className="editstoreText mb-0"></p>
          <div className="header-icon"> <button className="wallet-btn" onClick={() => window.open("https://stage-creatorpro.myjosh.in/affiliate_store/wallet?d_type=web", "_self")}><img src={walletIcon} alt="" /><span>Wallet</span> </button> </div>
        </div>
      </div>
      <div className="affiliate-dashboard">
        <div className="header-filter">
          <h2 className="card-title">OVERVIEW</h2> <div className="form-group">
            <div className="custom-dropdown">
              <div className="drop-down cursor-pointer">
                <div className="selected">
                  <a><span>Last 24 hours</span></a>
                </div>
                <div className="options">
                  <ul style={{ display: 'none' }}>
                    <li><a>Last 24 hours</a></li>
                    <li><a>Last 7 days</a></li>
                    <li><a>Last 30 days</a></li>
                    <li><a>Overall</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="affiliate-data-wrap">
          <div className="row">
            <div className="col-md-12">
              <div className="affiliate-dash-card chart1">
                <img className="collapse-arrow" src={downArrowWhite} onClick={onshowTotalSales} alt="" />
                <div className={`affiliate-dashboard ${dashboardDetails.cal_sale < 0 && 'danger-icon'}`}>
                  <img className="dash-icon" src={dahsIcon1} alt="" />
                  <span>Total Sales</span>
                  <p>{numberConversion(dashboardDetails?.total_sale) || 0} <span>{dashboardDetails.cal_sale > 0 && '+'}{numberConversion(dashboardDetails.cal_sale)}%</span> </p>
                </div>
                {showtotalsales &&
                  <div className='col-md-12 no-padding-mobile'>
                    <div className='graph-card graph-age'>
                      <Chart className="country-graph-card"
                        options={options2}
                        series={series2}
                        type="area"
                        // width={700}
                        height={300}
                      />
                    </div>
                  </div>
                }
              </div>
            </div>
            <div className="col-md-12">
              <div className="affiliate-dash-card chart2">
                <img className="collapse-arrow" onClick={onshowstorevisits} src={downArrowWhite} alt="" />
                <div className="visitors-wrap">
                  <div className={`affiliate-dashboard ${dashboardDetails.cal_visit_count < 0 && 'danger-icon'}`}>
                    <img className="dash-icon" src={dahsIcon2} alt="" />
                    <span>Store Visits</span>
                    <p>{numberConversion(dashboardDetails?.store_visit_count) || 0}  <span>{dashboardDetails.cal_visit_count > 0 && '+'}{numberConversion(dashboardDetails.cal_visit_count)}%</span></p>
                  </div>
                  <div className={`affiliate-dashboard click-icon ${dashboardDetails.cal_click < 0 && 'danger-icon'}`}>
                    <div className="dash-icon" ><img className="" src={dahsIcon3} alt="" /></div>

                    <span>Clicks</span>
                    <p>{numberConversion(dashboardDetails?.total_click) || 0}  <span>{dashboardDetails.cal_click > 0 && '+'}{numberConversion(dashboardDetails.cal_click)}%</span></p>
                  </div>
                </div>
                {showstorevisit &&
                  <div className='col-md-12 no-padding-mobile'>
                    <div className='graph-card graph-country'>
                      <Chart className="country-graph-card"
                        options={options3}
                        series={series3}
                        type="bar"
                        // width={700}
                        height={300}
                      />
                    </div>
                  </div>}
              </div>
            </div>
            <div className="col-md-12">
              <div className="affiliate-dash-card access-store-wrap">
                <div className="affiliate-dashboard cursor-pointer" onClick={() => handleStoreNavigate()}>
                  {storeDetails?.status !== undefined ? <div className="online-tag">
                    <span className={`${storeDetails?.status && "online-color"}`}> </span> {storeDetails?.actionStatus}
                  </div> : <></>}
                  <img className="dash-icon" src={dahsIcon4} alt="" />
                  <span>Access your store    <img src={rightArrow} alt="" /> </span>
                  <p>{dashboardDetails?.store_product_count || 0} Products added </p>
                </div>
                <div className="copy-link-wrap">
                  <h2>Copy store link</h2> <a href="javascript:void(0);"><img onClick={() => onCopyLink()} src={CopyLink} alt="" /></a>
                </div>
              </div>
            </div>
          </div>
          <div className="affiliate-list-wrap">
            <h2 className="card-title">Your Affiliates</h2>
            {loading && <AffiliateDashboardShimmer />}
            {product?.length > 0 ? <ul>
              {product?.map(prod => {
                return (
                  < li >
                    <a href="javascript:void(0);"><div className="brand-card-wrap">
                      <div className="brand-img">
                        <img src={prod?.image} alt="" />
                      </div>
                      <div className="brand-contant">
                        <h2 className="brand-product-name"> {prod?.pro_name || ""}</h2>
                        <div className="brand-amount-wrap">
                          <div className="brand-name">
                            <p>Clicks </p> <span>{prod.click || "N/A"}</span>
                          </div>
                          <div className="brand-name">
                            <p>Total Sales  </p> <span>{prod.sale || "N/A"}</span>
                          </div>
                        </div>
                        <div className="brand-amount-wrap">
                          <div className="brand-name">
                            <p>Total Earnings </p>
                            {/* <span>{prod.total_earning}</span> */}
                          </div>
                          <div className="brand-name">
                            <span className="eranings">₹ {prod?.total_earning + prod?.est_earning || 0}  </span>
                          </div>
                        </div>
                      </div>
                    </div></a>
                  </li>)
              })
              }
            </ul> : <div className="no_affiliate_1">
              <img src={no_affiliate_1} />
              <div className="common-btn">
                <button onClick={onAddProduct}>Add products to Store</button>
              </div>
            </div>
            }
            {!lastList && totalProducts > 12 && <div className="common-btn">
              <button onClick={onViewAllClick}>View All</button>
            </div>}
          </div>

        </div>
      </div>
    </>
  );
}

export default AffiliateDashboard;